export default "/assets/images/carbon-monoxide-video.mp4?c483fa870b8c47fbd8f3132298fbe85e";